import getConfig from "next/config";

const { publicRuntimeConfig } = getConfig() ?? {
  publicRuntimeConfig: {
    IS_PROD: false,
    IS_TEST: true,
  },
};

export const { endpointUrl, fetchParams } = {
  endpointUrl:
    (publicRuntimeConfig.IS_PROD ? "/api/v2" : "/api/v2") + "/graphql",
  fetchParams: {
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
    },
  },
};
